// import {
//     HTTP
// } from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        sample: 'This is sample content.'
    },
    getters: {},
    mutations: {},
    actions: {},
}